export const VendorUserRoles = [
    { "id": "vendor_admin", "name": "Vendor Admin" }, { "id": "vendor_light_user", "name": "Vendor Light User" }, { "id": "vendor_quotation", "name": "Vendor Quotation" }

]